// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","textActiveColor":"#7cf4fe"};